<div class="container-fluid">
  <div class="wrapper">
    <literax-auth-navbar
      [standalone]="true"
      [title]="'AUTH.TITLE.NAVBAR' | translate"
    ></literax-auth-navbar>
    <div nz-row>
      <div
        nz-col
        [nzXs]="{ span: 22, offset: 1 }"
        [nzSm]="{ span: 20, offset: 2 }"
        [nzMd]="{ span: 16, offset: 4 }"
        [nzLg]="{ span: 12, offset: 6 }"
        class="main-container"
      >
        <nz-card [nzTitle]="cardTitle">
          <nz-result
            nzStatus="403"
            nzTitle="{{ 'LINK_ERROR.TITLE' | translate }}"
            nzSubTitle="{{ 'LINK_ERROR.SUBTITLE' | translate }}"
          >
          </nz-result>
        </nz-card>
        <ng-template #cardTitle>
          <h4 style="text-align: center;">
            {{ 'LINK_ERROR.TOP_TITLE' | translate }}
          </h4>
        </ng-template>
      </div>
    </div>
  </div>
</div>
